import {
  PhoneWrapper
} from "./Styles";
import { PhoneInput, PhoneInputProps } from 'react-international-phone';
import 'react-international-phone/style.css';

import { useEffect, useState } from "react";

export function CustomPhoneInput(
  props: PhoneInputProps
) {
  const [inputValue, setValue] = useState(props.value);

  useEffect(() => {
    setValue(props.value)
  }, [props.value]);

  return(
    <PhoneWrapper>
      <PhoneInput
        {...props}
        value={inputValue}
        prefix=""
        defaultCountry="es"
        disableCountryGuess={true}
        forceDialCode={true}
        countrySelectorStyleProps={{
          style: {
            cursor: 'pointer',
          }
        }}
      />
    </PhoneWrapper>
  );
}
